 <template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{ $t("tlt.smeltingProductQuality") }}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <!-- <li class="breadcrumb-item"><router-link to="/prd"><span>{{$t('tlt.production')}}</span></router-link></li> -->
                    <li class="breadcrumb-item"><router-link to="/prd/smeltingProductionResult"><span>{{$t('tlt.smeltingProductionResult')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/smeltingProductionQuality"><span>{{$t('tlt.smeltingProductQuality')}}</span></router-link></li>
                </ul>
            </div>
        
        </div>
 <section class="app-content">
        <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show "
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter"
                        >
                        <div class="card-body">
                            <form class="row">
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.locName") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="locNameFilter"/>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.startDay") }} :
                                    </label>
                                    <mmf-datepicker      v-model="startDayFilter"></mmf-datepicker>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.endDay") }} :
                                    </label>
                                    <mmf-datepicker      v-model="endDayFilter"></mmf-datepicker>
                                </div>                            
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.shift") }} :
                                    </label>
                                    <select class="form-control" type="text" v-model="shiftFilter">
                                        <option value>{{ $t("lbl.basic.select.one") }}</option>
                                        <option value="甲">{{ $t("lbl.shift.A") }}</option>
                                        <option value="乙">{{ $t("lbl.shift.B") }}</option>  
                                        <option value="丙">{{ $t("lbl.shift.C") }}</option>
                                    </select>
                                </div>
                                                             
                                    <div class="col-lg-12 align-self-end">
                  <div class="float-lg-right">
                    <button
                      class="btn btn-outline-secondary mr-1"
                      type="button"
                      v-on:click="MMFClearFilter('smeltingProductionQuality')"
                    >
                      <i class="fa fa-fw fa-lg fa-eraser"></i>
                      <span class="text">{{ $t("btn.basic.clear") }}</span>
                    </button>
                    <button
                      class="btn btn-primary"
                      type="button"
                      v-on:click="MMFLoadRows('smeltingProductionQuality')"
                    >
                      <i class="fa fa-fw fa-lg fa-search"></i>
                      <span class="text">{{ $t("btn.basic.search") }}</span>
                    </button>
                  </div>
                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>


      <div id="smeltingProductionQualityTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component"></div>
              <mmf-table entity="smeltingProductionQuality" 
              inline-actions-disabled 
              singleChoice halfHeight 
              disableEdit disableDelete>
                    <div slot="btnList" class="btn-group" slot-scope="slotProps" :singleChoice='true'>                                   
                                    <button
                                        :disabled="slotProps.checkedLength!=1"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        v-on:click="Delete(entity)">
                                        <i class="fa fa-tasks" aria-hidden="true"></i>  
                                        <span class="text">{{$t('btn.basic.delete')}}</span>                                         
                                    </button>                 
                                </div>
              </mmf-table>
            </div>
          </div>
        </div>
      </div>
      <div id="smeltingProductionQualityItemTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component"></div>
              <mmf-table entity="smeltingProductionQualityItem"  
              inline-actions-disabled
              singleChoice 
              halfHeight 
              disableEdit 
              disableDelete 
             >
              </mmf-table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { gridFields ,filterFields} from "@/model/prd/productionExecution/smelting/SmeltingProductionQuality";
import { fields } from "@/model/prd/productionExecution/smelting/SmeltingProductionQuality";
import MmfTable from "@/components/MmfTable";
import MmfDatepicker from '@/components/MmfDatepicker';

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "smeltingProductionQuality/getField",
  mutationType: "smeltingProductionQuality/updateField"
});

export default {
  name: "smeltingProductionQualityList",
  data() {
    return {};
  },
  components: { MmfTable,MmfDatepicker },
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model

    ...mapFields(fields),
    ...mapFields(filterFields),
    ...mapState({
      rows: state => state.smeltingProductionQuality.rows,
      tableColumns: gridFields,
      entity: state => state.smeltingProductionQuality.entity,
      checkedItems: state => state.smeltingProductionQuality.checkedItems,
      baseModuleUrl :state=>state.smeltingProductionQuality.baseModuleUrl
    })
  },
  methods: {
    ...mapActions("base", ["MMFLoadRows", "MMFClearFilter"]),
    ...mapActions("smeltingProductionQualityItem", ["getDetails"]),
    ...mapActions("smeltingProductionQuality", ["Delete"]),
    ...mapMutations("smeltingProductionQualityItem",["setRows"])
  },

 
  watch: {
    checkedItems(newIdList) {
      console.log(newIdList);
      if (newIdList.length > 0) {
        let id = newIdList[0];
        this.getDetails(id);
      } else {
        this.setRows([]); // 清空
      }
    }
  }
};
</script>
